export default "__VITE_ASSET__Ip$z4Vxg__"